import * as api from "@/api/williams/users";
import { queryKeys } from "../../queryKeys";
import { useQuery } from "react-query";

export function usePermissions() {
  return useQuery({
    queryKey: queryKeys.user.permissions(),
    queryFn: api.getPermissions,
    staleTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: "always",
  });
}
